import Repository from '../Repository';
import { useToast } from 'vue-toastification';
import { serialize } from 'object-to-formdata';

const resource = '/company';
const toast = useToast();

export default {
	store(payload) {
		const formData = serialize(payload, { indices: true, nullsAsUndefineds: true });

		return Repository.post(`${resource}`, formData, { headers: { 'Content-Type': 'multipart/form-data' }}).then((response) => {
			toast.success(`Empresa creada correctamente.`);
			return response;
		});
	},
	show(id) {
		return Repository.get(`${resource}/${id}`);
	}
}